import React, { useContext } from 'react';
import { Modal } from 'antd';
import SubCategoriesTableForm from './SubCategoriesTableForm';
import SettingsSubCategoriesContext from '../../../contexts/settings-contexts/SettingsSubCategoriesProvider';
import { useTranslation } from 'react-i18next';

const SubCategoriesModal = ({ addModal }) => {
  const {
    modalOpened,
    setModalOpened,
    setSelectedSubCategory,
    selectedSubCategory
  } = useContext(SettingsSubCategoriesContext);
  const { t } = useTranslation();

  return (
    <Modal
      transitionName=""
      className="shared-custom-modal"
      width="90%"
      style={{ maxWidth: '742px' }}
      title={
        selectedSubCategory
          ? t('Inventory.Categories.editProductCategory')
          : t('Inventory.Categories.addNewProductCategory')
      }
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedSubCategory(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedSubCategory(null);
      }}
      footer={false}
    >
      <SubCategoriesTableForm addModal={addModal} />
    </Modal>
  );
};

export default SubCategoriesModal;
